import { render } from "./aiDropUpload.vue?vue&type=template&id=2432aab0&scoped=true"
import script from "./aiDropUpload.vue?vue&type=script&lang=js"
export * from "./aiDropUpload.vue?vue&type=script&lang=js"

import "./aiDropUpload.vue?vue&type=style&index=0&id=2432aab0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2432aab0"]])

export default __exports__